<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <div class="">
            <h2 class="!tw-text-xl !tw-font-semibold !tw-mb-3">
                {{ "REDEEM.TITLE" | translate }}
            </h2>

            <div
                class="tw-w-full tw-bg-white tw-rounded-xl tw-max-w-[930px] tw-min-h-[255px] tw-p-4 tw-relative tw-flex tw-items-center lg:tw-pl-[40px] tw-mb-7"
            >
                <div
                    class="tw-w-full md:tw-max-w-[350px] xl:tw-max-w-[405px] tw-h-full tw-flex tw-flex-col tw-gap-4 tw-justify-center"
                >
                    <img
                        class="tw-block md:tw-hidden tw-mb-5 tw-w-[272px]"
                        src="/assets/images/rewards.svg"
                    />

                    <h3 class="!tw-font-bold !tw-text-2xl !tw-mb-0">
                        {{ "REDEEM.HEADING" | translate }}
                    </h3>

                    <p class="!tw-text-[#2B2B2BCC] !tw-text-[15px] !tw-mb-0">
                        {{ "REDEEM.DESC" | translate }}
                    </p>

                    <form
                        [formGroup]="form"
                        (ngSubmit)="submitCode()"
                        class="tw-flex tw-flex-col tw-gap-1"
                    >
                        <div class="tw-flex">
                            <input
                                type="text"
                                formControlName="code"
                                maxlength="14"
                                (input)="onInputChange($event)"
                                class="tw-rounded-l-xl tw-border tw-p-4 tw-w-full"
                                [placeholder]="'REDEEM.PLACEHOLDER' | translate"
                            />
                            <button
                                type="submit"
                                class="tw-rounded-r-xl tw-p-4 tw-text-white tw-w-[139px]"
                                [ngClass]="
                                    form.invalid
                                        ? 'tw-bg-[#7B7575]'
                                        : 'tw-bg-[#0A0A75]'
                                "
                            >
                                {{ "REDEEM.CTA" | translate }}
                            </button>
                        </div>

                        <div class="tw-min-h-[20px]">
                            <span
                                *ngIf="err"
                                class="tw-text-[#7B7575] tw-text-sm tw-flex tw-gap-2 tw-items-start lg:tw-items-center tw-mt-1"
                            >
                                <svg
                                    width="21"
                                    height="20"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="10.5"
                                        cy="10"
                                        r="10"
                                        fill="#FF8A00"
                                    />
                                    <path
                                        d="M15.207 6.70787L11.9136 10L15.207 13.2921C15.2999 13.385 15.3736 13.4953 15.4238 13.6167C15.4741 13.7381 15.5 13.8682 15.5 13.9996C15.5 14.1309 15.4741 14.261 15.4238 14.3824C15.3736 14.5038 15.2999 14.6141 15.207 14.707C15.1141 14.7999 15.0038 14.8736 14.8824 14.9238C14.761 14.9741 14.6309 15 14.4996 15C14.3682 15 14.2381 14.9741 14.1167 14.9238C13.9953 14.8736 13.885 14.7999 13.7921 14.707L10.5 11.4136L7.20787 14.707C7.11497 14.7999 7.00468 14.8736 6.8833 14.9238C6.76192 14.9741 6.63183 15 6.50045 15C6.36906 15 6.23897 14.9741 6.11759 14.9238C5.99621 14.8736 5.88592 14.7999 5.79302 14.707C5.70012 14.6141 5.62643 14.5038 5.57615 14.3824C5.52588 14.261 5.5 14.1309 5.5 13.9996C5.5 13.8682 5.52588 13.7381 5.57615 13.6167C5.62643 13.4953 5.70012 13.385 5.79302 13.2921L9.08641 10L5.79302 6.70787C5.6054 6.52025 5.5 6.26578 5.5 6.00044C5.5 5.73511 5.6054 5.48064 5.79302 5.29302C5.98064 5.1054 6.23511 5 6.50045 5C6.76578 5 7.02025 5.1054 7.20787 5.29302L10.5 8.58641L13.7921 5.29302C13.885 5.20012 13.9953 5.12643 14.1167 5.07615C14.2381 5.02588 14.3682 5 14.4996 5C14.6309 5 14.761 5.02588 14.8824 5.07615C15.0038 5.12643 15.1141 5.20012 15.207 5.29302C15.2999 5.38592 15.3736 5.49621 15.4238 5.61759C15.4741 5.73897 15.5 5.86906 15.5 6.00044C15.5 6.13182 15.4741 6.26192 15.4238 6.3833C15.3736 6.50468 15.2999 6.61497 15.207 6.70787Z"
                                        fill="white"
                                    />
                                </svg>

                                {{ err | translate }}
                            </span>
                        </div>
                    </form>
                </div>

                <img
                    class="tw-absolute tw-bottom-0 tw-right-9 md:tw-w-[260px] xl:tw-w-auto tw-hidden md:tw-block"
                    src="/assets/images/rewards.svg"
                />
            </div>

            <div
                class="tw-w-full tw-bg-white tw-rounded-xl tw-max-w-[422px] tw-flex tw-justify-center tw-items-center tw-min-h-[255px] tw-p-4 tw-relative"
            >
                <div class="tw-max-w-[355px] tw-mx-auto">
                    <h3 class="!tw-font-bold !tw-text-2xl !tw-mb-1">
                        {{ "PROFILE.REFER.TITLE" | translate }}
                    </h3>
                    <p class="!tw-text-[#2B2B2BCC] !tw-text-[15px] !tw-mb-5">
                        {{ "PROFILE.REFER.DESCRIPTION" | translate }}
                    </p>

                    <div
                        class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-pr-5"
                    >
                        <img
                            *ngFor="let i of completedChecks"
                            src="/assets/images/icons/referral_check.svg"
                        />
                        <img
                            *ngFor="let i of incompleteChecks"
                            src="/assets/images/icons/referral_check_empty.svg"
                        />

                        <img src="/assets/images/icons/referral_gift.svg" />
                    </div>
                </div>
            </div>
        </div>
    </app-dashboard-wrapper>
</div>
<app-loader [showLoader]="isLoading"></app-loader>
